import type { RfqSubmission } from '../types';

export function submissionQuoteTotal(sub: RfqSubmission | null | undefined): number | null {
  if (!sub || sub.notBidding) return null;
  if (typeof sub.quoteTotal === 'number' && sub.quoteTotal > 0) return sub.quoteTotal;
  if (typeof sub.cncQuote?.totalEstimate === 'number' && sub.cncQuote.totalEstimate > 0) {
    return sub.cncQuote.totalEstimate;
  }
  return null;
}

export function formatQuoteTotal(amount: number | null | undefined): string {
  if (amount == null || !Number.isFinite(amount) || amount <= 0) return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function parseQuoteTotalInput(raw: string): number | null {
  const trimmed = raw.trim().replace(/[$,\s]/g, '');
  if (!trimmed) return null;
  const n = parseFloat(trimmed);
  if (!Number.isFinite(n) || n <= 0) return null;
  return Math.round(n * 100) / 100;
}

export function isValidQuoteTotal(amount: number | null | undefined): amount is number {
  return typeof amount === 'number' && Number.isFinite(amount) && amount > 0;
}
